var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarsV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bars-v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3333 13.3333V2.66667C11.3333 2.29847 11.6319 2 12 2H13.3333C13.7015 2 14 2.29847 14 2.66667V13.3333C14 13.7015 13.7015 14 13.3333 14H12C11.6319 14 11.3333 13.7015 11.3333 13.3333ZM7.33333 14H8.66667C9.03487 14 9.33333 13.7015 9.33333 13.3333V2.66667C9.33333 2.29847 9.03487 2 8.66667 2H7.33333C6.9652 2 6.66667 2.29847 6.66667 2.66667V13.3333C6.66667 13.7015 6.9652 14 7.33333 14ZM2.66667 14H4C4.3682 14 4.66667 13.7015 4.66667 13.3333V2.66667C4.66667 2.29847 4.3682 2 4 2H2.66667C2.29853 2 2 2.29847 2 2.66667V13.3333C2 13.7015 2.29853 14 2.66667 14Z",
    fill: "#16162C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsV);
export default __webpack_public_path__ + "static/media/bars-v.0c65529f6662a888f610ada841d66738.svg";
export { ForwardRef as ReactComponent };